<template>
  <div class="mian-article">
      <div class="width1200">
          <div class="header">
              <p style="text-align:right;">已有帐号？
                <span @click="login" class="go-login">去登录</span>
            </p>
            <h1>用户注册</h1>
          </div>
          <div class="sub-form">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="登录名" prop="loginname">
                        <el-input v-model="ruleForm.loginname"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="loginpwd">
                        <el-input v-model="ruleForm.loginpwd" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="rePassword">
                        <el-input v-model="ruleForm.rePassword" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="用户类别" prop="typeinfo">
                        <el-select v-model="ruleForm.typeinfo" placeholder="请选择用户类别" @change="changeRules">
                        <el-option label="外部用户" value="2"></el-option>
                        <el-option label="中山大学用户" value="1"></el-option>
                        <el-option label="南方海洋科学与工程广东省实验室（珠海）" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <div class="waibu" v-if="ruleForm.typeinfo==2">
                        <el-form-item label="工作单位" prop="useraddress" key="useraddress">
                            <el-input v-model="ruleForm.useraddress"></el-input>
                        </el-form-item>
                    </div>
                    <div class="neibu" v-else>
                        <el-form-item label="学院名称" prop="collegename" key="collegename">
                            <el-input v-model="ruleForm.collegename"></el-input>
                        </el-form-item>
                        <el-form-item label="校园卡号" prop="collegecard" key="collegecard">
                            <el-input v-model="ruleForm.collegecard"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="真实姓名" prop="username">
                        <el-input v-model="ruleForm.username"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="userphone">
                        <el-input v-model="ruleForm.userphone"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="useremail">
                        <el-input v-model="ruleForm.useremail"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="captcha" class="ver-code">
                        <el-input v-model="ruleForm.captcha" ></el-input>
                        <div class="ver" @click="getCaptcha">
                            <img :src="captchaUrl" alt="">
                        </div>
                    </el-form-item>
                    <el-form-item class="center">
                        <el-button type="primary" :disabled="!ruleForm.captcha" class="btn-sub" @click="submitForm('ruleForm')">立即创建</el-button>
                    </el-form-item>
                </el-form>
          </div>
      </div>
  </div>
</template>

<script>
import { 
    captcha,
    createUser
} from "@/api/user/index"
import axios from 'axios'
export default {
    components:{
    },
    data(){
        var checkPhone = (rule, value, callback) => {
            const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
            if (!value) {
            return callback(new Error('电话号码不能为空'))
            }
            setTimeout(() => {
            // Number.isInteger是es6验证数字是否为整数的方法,但是我实际用的时候输入的数字总是识别成字符串
            // 所以我就在前面加了一个+实现隐式转换

            if (!Number.isInteger(+value)) {
                callback(new Error('请输入数字值'))
            } else {
                if (phoneReg.test(value)) {
                callback()
                } else {
                callback(new Error('电话号码格式不正确'))
                }
            }
            }, 100)
        }
        var checkEmail = (rule, value, callback) => {
            const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
            if (!value) {
            return callback(new Error('邮箱不能为空'))
            }
            setTimeout(() => {
            if (mailReg.test(value)) {
                callback()
            } else {
                callback(new Error('请输入正确的邮箱格式'))
            }
            }, 100)
        }
        return {
            captchaUrl:'',
            randomString:'',
            ruleForm:{
                loginname:'',
                loginpwd:'',
                rePassword:'',
                typeinfo:'2',
                useraddress:'',
                collegename:'',
                collegecard:'',
                username:'',
                userphone:'',
                useremail:'',
                captcha:'',
            },
            rules:{},
            rules1: {
                loginname: [
                    { required: true, message: '请输入登录名', trigger: 'blur' },
                    { min: 3, message: '长度最少 3 个字符', trigger: 'blur' }
                ],
                loginpwd: [
                    { required: true, message: '请选择密码', trigger: 'blur' },
                    { min: 6,max:12, message: '长度 6~12 个字符', trigger: 'blur' }
                ],
                rePassword: [
                    {required: true, message: '请输入确认密码', trigger: 'blur' },
                    { min: 6, max:12,message: '长度 6~12 个字符', trigger: 'blur' }
                ],
                typeinfo: [
                    { required: true, message: '请输入用户类别', trigger: 'blur' },
                ],
                useraddress: [
                    { required: true, message: '请输入工作单位', trigger: 'blur' },
                ],
                username: [
                    { required: true, message: '请填写真实姓名', trigger: 'blur' }
                ],
                userphone: [
                    { validator: checkPhone,required: true,  trigger: 'blur' }
                ],
                useremail: [
                    { validator: checkEmail,required: true, mtrigger: 'blur' }
                ],
                captcha: [
                    { required: true, message: '请填写验证码', trigger: 'blur' }
                ]
            },
            rules2: {
                loginname: [
                    { required: true, message: '请输入登录名', trigger: 'blur' },
                    { min: 3, message: '长度最少 3 个字符', trigger: 'blur' }
                ],
                loginpwd: [
                    { required: true, message: '请选择密码', trigger: 'blur' },
                    { min: 6,max:12, message: '长度 6~12 个字符', trigger: 'blur' }
                ],
                rePassword: [
                    {required: true, message: '请输入确认密码', trigger: 'blur' },
                    { min: 6, max:12,message: '长度 6~12 个字符', trigger: 'blur' }
                ],
                typeinfo: [
                    { required: true, message: '请输入用户类别', trigger: 'blur' },
                ],
                collegename: [
                    { required: true, message: '请选择学院名称', trigger: 'blur' }
                ],
                collegecard: [
                    { required: true, message: '请填写校园卡号', trigger: 'blur' },
                    { min: 6,max:6, message: '长度是 6 个字符', trigger: 'blur' }
                ],
                username: [
                    { required: true, message: '请填写真实姓名', trigger: 'blur' }
                ],
                userphone: [
                    { validator: checkPhone,required: true,  trigger: 'blur' }
                ],
                useremail: [
                    { validator: checkEmail,required: true, trigger: 'blur' }
                ],
                captcha: [
                    { required: true, message: '请填写验证码', trigger: 'blur' }
                ]
            }
        }
    },
    methods:{
        login(){
            axios.get('config/AllUrl.json').then(res => {
                if (res) {
                    let sevice = "http://" + window.location.host +'/';
                    window.location.href = res.loginHeader+'?service='+encodeURIComponent(sevice)
                }
            })
        },
        randomStringFuc(e) {  
            e = e || 32;
            var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
            a = t.length,
            n = "";
            for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
            return n
        },
        async getCaptcha(){
            this.randomString = this.randomStringFuc(6)
            let res = await captcha(this.randomString)
            console.log(res);
            this.captchaUrl = res.data
        },
        changeRules(val){
            let that = this
            if(val==='3'){
                this.rules = this.rules1
            }else{
                this.rules = this.rules2
            }
            
            this.ruleForm.typeinfo = val
            setTimeout(() =>{
                that.$refs.ruleForm.clearValidate();
            },10)
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                this.addUser()
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        async addUser(){
            let that = this
            console.log(that.randomString);
            console.log(that.ruleForm);
            if(that.ruleForm.rePassword!=that.ruleForm.loginpwd){
                that.$message.error('两次密码填写不相同！')
                return
            }
            let params = JSON.parse(
                JSON.stringify(
                    {
                        ...that.ruleForm,
                        ...{checkKey:that.randomString}
                    }
                )
            )
            
            if(that.ruleForm.typeinfo==='2'){
                delete params.collegename
                delete params.collegecard
            }else{
                delete params.useraddress
            }
            if(that.ruleForm.typeinfo==="3"){
                params.typeinfo = "1"
            }
            let res = await createUser(params)
            if(res.code==='SUCCESS'){
                that.$message.success('注册成功！')
            }else{
                const messageInfo = res.message
                that.$message.error(messageInfo||'注册失败，请检查个人信息后重新提交！')
            }
        },
    },
    created(){
        this.rules = this.rules1
        this.getCaptcha()
    }
}
</script>

<style scoped lang="scss">
/deep/.ver-code .el-form-item__content{
    display: flex;
}
.mian-article{
    .width1200{
        width: 1000px;
        margin: 0 auto;
        padding: 48px 0;
    }
    .header{
        border-bottom: 1px solid #383838;
    }
    .sub-form{
        width: 600px;
        margin: 0 auto;
        margin-top: 24px;
    }
    .ver{
        margin-left: 24px;
        width: 120px;
        height: 40px;
        background: red;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
.go-login{
    color: rgb(3,165,252);
    text-decoration:underline;
    cursor: pointer;
}
</style>